
import Component, { mixins } from "vue-class-component"
import FilialeHeader from "../custom/FilialeHeader.vue"
import BezahlenLogic from "@/logic/bestellung/bezahlen_logic"
import Calculator from "../mixins/Calculator.vue"

@Component({ components: { FilialeHeader } })
export default class Bezahlen extends mixins(Calculator) {
  logic: BezahlenLogic = null

  mounted() {
    this.logic = new BezahlenLogic()
    this.logic.init()
  }

  weiter() {
    this.logic.weiterTrinkgeld()
  }
}
